import React from 'react'
import styled from 'styled-components'

const StyledInputText = styled.input<{ $error?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--colBlack);
  padding: 10px 14px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid ${({ $error }) => ($error ? 'red' : 'var(--colGray3)')};
  background-color: var(--colWhite);
  &:disabled {
    color: var(--colGray6);
  }
  @media screen and (min-width: 768px) {
    font-size: 15px;
    padding: 13px 14px;
    &:disabled {
      color: var(--colGray6);
    }
  }
`

export interface InputTextProps extends React.InputHTMLAttributes<HTMLInputElement> {
  $error?: boolean
  $focus?: boolean
}

export const InputText = React.forwardRef<HTMLInputElement, InputTextProps>((props, ref) => {
  return <StyledInputText ref={ref} {...props} />
})
InputText.displayName = 'InputText'

export const InputTextTitle = styled.p`
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  color: var(--colGray6);
  word-break: keep-all;
  min-width: 80px;
  @media screen and (min-width: 768px) {
    min-width: 120px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
`

export const TextWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  & p {
    color: var(--colGray6);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    margin-top: 8px;
  }
`

export const InputTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* padding: 0 24px; */
  @media screen and (min-width: 768px) {
    width: 100%;
    gap: 10px;
  }
`

export const InputTextDiv = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  @media screen and (min-width: 768px) {
    gap: 20px;
  }
`
